// extracted by mini-css-extract-plugin
export default {"layout":"cell_layout__qchMt","contact":"cell_contact__xXLiA","placeholder":"cell_placeholder__aLouh"};